/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useState, useRef, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'
import {currentCountry} from '../../../../config/countryConfig'

const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'lo',
    name: 'ລາວ',
    flag: toAbsoluteUrl('/media/flags/laos.svg'),
  },
]

const COUNTRY_LANGUAGES: Record<string, string[]> = {
  LA: ['lo', 'en'],
}

const Languages: FC = () => {
  const lang = useLang()
  const allowedLangs = COUNTRY_LANGUAGES[currentCountry]
  const visibleLanguages = allowedLangs
    ? languages.filter((l) => allowedLangs.includes(l.lang))
    : languages
  const currentLanguage = visibleLanguages.find((x) => x.lang === lang)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          Language
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {currentLanguage?.name}{' '}
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={currentLanguage?.flag}
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {visibleLanguages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

const LanguagesNavbar: FC = () => {
  const lang = useLang()
  const allowedLangs = COUNTRY_LANGUAGES[currentCountry]
  const visibleLanguages = allowedLangs
    ? languages.filter((l) => allowedLangs.includes(l.lang))
    : languages
  const currentLanguage = visibleLanguages.find((x) => x.lang === lang)

  return (
    <>
      <a
        href='#'
        className='btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
        data-kt-menu-trigger='click'
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <img
          className='w-20px h-20px rounded-1'
          src={currentLanguage?.flag}
          alt={currentLanguage?.name}
        />
      </a>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 fw-semibold py-4 fs-6 w-175px'
        data-kt-menu='true'
      >
        {visibleLanguages.map((l) => (
          <div className='menu-item px-3' key={l.lang} onClick={() => setLanguage(l.lang)}>
            <a href='#' className={clsx('menu-link d-flex px-5', {active: l.lang === lang})}>
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt={l.name} />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </>
  )
}

const LanguagePicker: FC = () => {
  const lang = useLang()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const allowedLangs = COUNTRY_LANGUAGES[currentCountry]
  const visibleLanguages = allowedLangs
    ? languages.filter((l) => allowedLangs.includes(l.lang))
    : languages
  const currentLanguage = visibleLanguages.find((x) => x.lang === lang)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={ref} style={{position: 'relative'}}>
      <button
        type='button'
        className='btn btn-light btn-sm d-flex align-items-center gap-2 px-3'
        onClick={() => setOpen((o) => !o)}
      >
        <img className='w-20px h-20px rounded-1' src={currentLanguage?.flag} alt={currentLanguage?.name} />
        <span className='fw-semibold text-gray-700 fs-7'>{currentLanguage?.name}</span>
        <i className='ki-duotone ki-down fs-8 text-gray-500' />
      </button>
      {open && (
        <div
          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 fw-semibold py-4 fs-6 w-175px show'
          style={{position: 'absolute', right: 0, top: '100%', zIndex: 1000}}
        >
          {visibleLanguages.map((l) => (
            <div
              className='menu-item px-3'
              key={l.lang}
              onClick={() => {
                setLanguage(l.lang)
                setOpen(false)
              }}
            >
              <a href='#' className={clsx('menu-link d-flex px-5', {active: l.lang === lang})}>
                <span className='symbol symbol-20px me-4'>
                  <img className='rounded-1' src={l.flag} alt={l.name} />
                </span>
                {l.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export {Languages, LanguagesNavbar, LanguagePicker}
